import { render, staticRenderFns } from "./MultipleAddress.vue?vue&type=template&id=6beb99b0&"
import script from "./MultipleAddress.vue?vue&type=script&lang=js&"
export * from "./MultipleAddress.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports